var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 32,
    viewBox: "0 0 86 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "404_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.76 0c2.613 0 4.747.473 6.4 1.42 1.653.947 2.947 2.147 3.88 3.6a13.751 13.751 0 011.92 4.8c.347 1.747.52 3.407.52 4.98 0 1.04-.073 2.14-.22 3.3a18.9 18.9 0 01-.76 3.42 15.06 15.06 0 01-1.46 3.2 10.394 10.394 0 01-2.34 2.68c-.947.773-2.073 1.387-3.38 1.84-1.307.453-2.827.68-4.56.68-1.733 0-3.253-.227-4.56-.68-1.307-.453-2.427-1.067-3.36-1.84a10.923 10.923 0 01-2.34-2.68 14.5 14.5 0 01-1.48-3.2 18.945 18.945 0 01-.76-3.4 26.178 26.178 0 01-.22-3.32c0-1.04.073-2.133.22-3.28.147-1.147.4-2.267.76-3.36a13.92 13.92 0 011.48-3.12 10.57 10.57 0 012.34-2.6c.933-.747 2.053-1.34 3.36-1.78C37.507.22 39.027 0 40.76 0zM22.24.8v15.88h3.84v7.44h-3.8v5h-8.64v-5H0v-7.76L10.72.8h11.52zm55.52 12.32c-5.523 0-10 4.477-10 10 0 .338.017.672.05 1.001L56 24.12v-7.76L66.72.8h11.52l.001 12.331c-.16-.007-.32-.011-.481-.011zm-37-4.92c-.587 0-1.067.2-1.44.6-.373.4-.667.92-.88 1.56A9.95 9.95 0 0038 12.5a22.734 22.734 0 000 4.68c.08.813.227 1.553.44 2.22.213.667.507 1.207.88 1.62.373.413.853.62 1.44.62s1.073-.207 1.46-.62c.387-.413.68-.953.88-1.62.2-.667.34-1.407.42-2.22a22.734 22.734 0 000-4.68c-.08-.787-.22-1.5-.42-2.14-.2-.64-.493-1.16-.88-1.56-.387-.4-.873-.6-1.46-.6zm-27 1.32h-.16l-4.72 7.16h4.88V9.52zm56 0h-.16l-4.72 7.16h4.88V9.52z",
    fill: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1a8 8 0 017.996 7.75L17 9a8 8 0 01-7.75 7.996L9 17A8 8 0 019 1zm0 10.752a1.25 1.25 0 00-1.244 1.122l-.006.128.006.127a1.25 1.25 0 001.116 1.116l.128.007.128-.007A1.25 1.25 0 009 11.752zM8.174 4l-.084.006c-.192.03-.338.169-.34.335v.02l.38 5.815.013.067c.049.15.215.259.41.257h.893l.082-.006c.185-.028.33-.157.342-.318l.38-5.816-.005-.07c-.031-.158-.194-.283-.397-.29H8.174z",
    transform: "translate(68.76 14.12)",
    fill: "url(#404_svg__[object_Object]a)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default ForwardRef;